import { Typography, Stack } from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import sampleReading from "../assets/sample reading.PNG";

const ReadingReportInstructions = ({ languageId }) => {
  return (
    <Box sx={{ margin: 3 }}>
      <Typography variant="h6" component="div">
        {languageId === 2 ? "解讀讀數結果：" : "Interpreting the reading result:"}
      </Typography>
      <Stack direction="row" justifyContent="space-between">
        <img
          src={sampleReading}
          alt=" showing an example graph of the reading component"
          style={{ width: "25%", height: "25%" }}
        />
        <Box sx={{ pl: "11vw" }}>
          <br />
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `
              每個圖表都代表您的孩子在閱讀每篇文章或每個章節時的閱讀速度和準確率，具體取決於您正在閱讀的報告類型。
            ` : `
              Each graph represents your child's reading speed and accuracy for
              each passage or strand depending on the type of report you are
              reading.
            `}
          </Typography>
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `
              圖表上用一個紅點表示你孩子的位置，旁邊寫著「你」字。
            ` : `
              Your child's position on the graph is denoted by a red dot with the
              word "You" written next to it.
            `}
          </Typography>
          <br />
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `
              此圖表分為兩個軸，橫軸表示速度，縱軸表示準確度。
            ` : `
              The graph is split into two axes, speed on the horizontal axis and
              accuracy on the vertical.
            `}
          </Typography>
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `
              圖表右側附近的學生比同屆其他學生完成題目的速度更快。
            ` : `
              Students who are closer to the right side of the graph complete
              questions faster than other students in their cohort.
            `}
          </Typography>
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `
              圖表中排名靠前的學生比同屆其他學生答對的問題更多。
            ` : `
              Students who are closer to the top of the graph answer more
              questions correct compared to other students in their cohort.
            `}
          </Typography>
          <br />
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `
              理想情況下，學生的目標是排在右上角，這表明他們能夠快速且準確地完成問題。
            ` : `
              Ideally, students aim to be placed in the top right corner, which
              shows that they are able to complete questions quickly and
              accurately.
            `}
          </Typography>
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `
              左上角的學生能夠準確回答問題，但需要提高速度。
            ` : `
              Students in the top left corner are able to answer questions
              accurately but need to improve their speed.
            `}
          </Typography>
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `
              右下角的學生能夠快速回答問題，但需要提高準確率。
            ` : `
              Students in the bottom right corner are able to answer questions
              quickly but need to improve their accuracy.
            `}
          </Typography>
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? `左下角的學生需要提高速度和準確度。` : `
              Students in the bottom left corner need to improve both their speed
              and accuracy.
            `}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default ReadingReportInstructions;
